var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return !_vm.isEmpty
    ? _c(
        "div",
        { staticClass: "mt-3" },
        [
          _vm._m(0),
          _vm._l(_vm.specialists, function(specialist) {
            return _c(
              "div",
              { key: specialist.supervisedId },
              [
                _c("custom-callout", { staticClass: "mb-3" }, [
                  _c("div", { staticClass: "row" }, [
                    _c("div", { staticClass: "col-sm" }, [
                      _c("span", { staticClass: "data-name" }, [
                        _vm._v("Tipo:")
                      ]),
                      _c("p", { staticClass: "data" }, [
                        _vm._v(_vm._s(specialist.supervisedTypeName))
                      ])
                    ]),
                    _c("div", { staticClass: "col-sm" }, [
                      _c("span", { staticClass: "data-name" }, [
                        _vm._v("Nombre:")
                      ]),
                      _c("p", { staticClass: "data" }, [
                        _vm._v(_vm._s(specialist.specialistName))
                      ])
                    ]),
                    _c("div", { staticClass: "col-sm" }, [
                      _c("span", { staticClass: "data-name" }, [
                        _vm._v("Número Seguro Social:")
                      ]),
                      _c("p", { staticClass: "data" }, [
                        _vm._v(_vm._s(specialist.socialSecurity))
                      ])
                    ]),
                    _c("div", { staticClass: "col-sm" }, [
                      _c("span", { staticClass: "data-name" }, [
                        _vm._v("Especialidad(es):")
                      ]),
                      _c("p", { staticClass: "data" }, [
                        _vm._v(_vm._s(specialist.specialist_DisciplineName))
                      ])
                    ]),
                    !_vm.disabled
                      ? _c("div", { staticClass: "col-sm" }, [
                          _c(
                            "div",
                            {
                              staticClass: "col d-flex justify-content-end mt-3"
                            },
                            [
                              _c("action-button", {
                                attrs: {
                                  i: "fa fa-times-circle",
                                  text: "Remover",
                                  variant: "outline-danger"
                                },
                                on: {
                                  click: function($event) {
                                    return _vm.removeSpecialist(
                                      specialist.supervisedId
                                    )
                                  }
                                }
                              })
                            ],
                            1
                          )
                        ])
                      : _vm._e()
                  ])
                ])
              ],
              1
            )
          }),
          _vm.showPagination
            ? _c("pagination", {
                attrs: { data: _vm.pagination },
                on: {
                  "pagination-go-page": function($event) {
                    _vm.currentPage = $event
                  }
                }
              })
            : _vm._e()
        ],
        2
      )
    : _vm._e()
}
var staticRenderFns = [
  function() {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "p-3" }, [
      _c("div", { staticClass: "row mb-3" }, [
        _c("div", { staticClass: "col" }, [
          _c("em", {
            staticClass:
              "fas fa-user-alt rounded-circle shadow p-2 color-primary-2 mr-2"
          }),
          _c("span", [
            _vm._v("Practicantes/Internos/Especialistas Seleccionados")
          ])
        ])
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }